import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class FiltersService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listTypesServices(filters = "") {
    return this.http.get(this.api+`/filtro/tipo-servico${filters}`);
  }

  listRegionsStates(filters = "") {
    return this.http.get(this.api+`/filtro/regiao${filters}`);
  }

  listAreas(filters = "") {
    return this.http.get(this.api+`/filtro/area${filters}`);
  }

  listEquipments(filters = "") {
    return this.http.get(this.api+`/filtro/equipamento${filters}`);
  }

  listProviders(filters = "") {
    return this.http.get(this.api+`/filtro/prestador-servico${filters}`);
  }

  listStores(filters = "") {
    return this.http.get(this.api+`/filtro/loja${filters}`);
  }

  listStatus(filters = "") {
    return this.http.get(this.api+`/filtro/status-requisicao${filters}`);
  }

  listFlags(filters = "") {
    return this.http.get(this.api+`/filtro/logomarca${filters}`);
  }

  listServices(filters = "") {
    return this.http.get(this.api+`/filtro/tipo-servico${filters}`);
  }
}
